// src/services/dialerService.js
import api from './api';

export const startDialer = (data) => {
    return api.post('/dialer/start', data);
};

export const stopDialer = (data) => {
    return api.post('/dialer/stop', data);
};

export const getDialerStatus = (campaignId) => {
    return api.get(`/dialer/status?campaignId=${campaignId}`);
};
